const FIELD_UPLOAD = {
  UPLOAD: 'Upload',
};

export { FIELD_UPLOAD };
